// extracted by mini-css-extract-plugin
module.exports = {"firstControlUnit":"_1zOUPTSDLT1DWpoDVrj6k6","secondControlUnit":"_3So-Y8vm767FgoMinPkiuP"};